import React, { useState, useEffect, useMemo } from "react";
import { hasPermission } from "../utils/permissionHelper";
import Access from "../components/access";
import axios from "axios";
import "../css/vehicle.css";
import useAuthRedirect from "../hooks/useAuthRedirect";
import InventoryNav from "../components/inventoryNav";
import Time from "../components/time";
import { Link } from "react-router-dom";

const SupplierMasterView = () => {
 useAuthRedirect();
  const [data, setData] = useState([]);
  const branch = localStorage.getItem("branch");
  const [filteredData, setFilteredData] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage] = useState(10);
  const [loading, setLoading] = useState(false);

   /////////////////////////////////////////////////////////////
      const rawPerms = useMemo(() => localStorage.getItem("permissions") || localStorage.getItem("userPermissions"), []);
        const permsLoaded = !!rawPerms;
        
        //✅ Permission checks (safe even if perms not yet loaded; will be false)
        const canView  = hasPermission("Supplier With Item", "view");
        const canEntry = hasPermission("Supplier With Item", "entry");
        const canEdit = hasPermission("Supplier With Item", "edit");
        const canDel = hasPermission("Supplier With Item", "del");
        /////////////////////////////////////////////////////////////
     


  useEffect(() => {
    fetchData();
  }, [branch]);

  const fetchData = async () => {
    setLoading(true);
    try {
      const response = await axios.get(`https://rfs2.infraconsoft.net.in/api/supplierMaster_list?branch=${branch}`);

      console.log("API Response:", response.data.supplierList);
      setData(response.data.supplierList);
      setFilteredData(response.data.supplierList);
    } catch (error) {
      console.error("Error fetching supplierList:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleSearch = (e) => {
    const term = e.target.value.toLowerCase();
    setSearchTerm(term);
  
    if (term === "") {
      setFilteredData(data);
      return;
    }
  
    const filtered = data.filter((item) =>
      (String(item.supplierMaster_code || "").toLowerCase().includes(term) ||
       String(item.supplierMaster_name || "").toLowerCase().includes(term))
    );
  
    setFilteredData(filtered);
  };
  
if (!canView) {
    return (
      <div id="admin-container">
        <InventoryNav />
        <div className="content-right" style={{ padding: 20 }}>
          <Access />
        </div>
      </div>
    );
  }

  // Pagination
  const paginate = (pageNumber) => setCurrentPage(pageNumber);
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentData = filteredData.slice(indexOfFirstItem, indexOfLastItem);

  return (
    <div id="admin-container">
      <InventoryNav />
      <div className="content-right">
        <section>
          <h2 className="add-txt">Supplier Master View</h2>
          <Time />
        </section>



        {/* Add New Button */}
        {canEntry && (
        <div className="add-new-container">
          <Link to={`/inventory/addModifier`}>
            <button className="add-new-btn">
              <i className="fa-solid fa-plus"></i> Add New
            </button>
          </Link>
        </div>
        )}

        {/* Search Filter */}
        <div className="search-filter">
          <p>Search: </p>
          <input
            type="text"
            placeholder="Search by Supplier"
            value={searchTerm}
            onChange={handleSearch}
            className="search-input"
          />
        </div>

        {/* Table */}
        <div className="content-table">
          <table>
            <thead>
              <tr>
              <th>S.No</th>
              <th>Supplier Code</th>
              <th>Supplier Name</th>
              <th>City</th>
               {canEntry && (
                    <th>Add Item</th>
                    )}
               {canView && (
                    <th>View</th>
                    )}
              {canEdit && (
                    <th>Modify</th>
                    )}
              
              </tr>
            </thead>
            <tbody>
              {loading ? (
                <tr>
                  <td colSpan="6" className="loading-text">Loading data, please wait...</td>
                </tr>
              ) : currentData.length > 0 ? (
                currentData.map((item, index) => (
                  <tr key={index}>
                    <td>{indexOfFirstItem + index + 1}</td>
                    <td>{item.supplierMaster_code}</td>
                    <td>{item.supplierMaster_name}</td>
                    <td>{item.supplierMaster_city}</td>
                    {canEntry && (
                    <td>
                      <Link to={`/inventory/addNewSupplierWithItem/${item.supplierMaster_code}/${item.supplierMaster_name}`}>
                        Add Item
                      </Link>
                    </td>
                    )}
                    

                                   {canView && (
                                        <td> 
                      <Link to={`/inventory/modifySupplierView/${item.supplierMaster_code}`}>
                        View
                      </Link>
                    </td>
                    )}

                    {canEdit && (
                    <td>
                      <Link to={`/inventory/modifySupplier/${item.supplierMaster_code}`}>
                        Modify
                      </Link>
                    </td>
                    
                    )}
                    
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="6">No Data Available</td>
                </tr>
              )}
            </tbody>
          </table>
        </div>

        {/* Pagination */}
        <div className="pagination">
          <button onClick={() => paginate(currentPage - 1)} disabled={currentPage === 1}>
            Previous
          </button>

          {/* Always show first page */}
          <button onClick={() => paginate(1)} className={currentPage === 1 ? 'active' : ''}>
            1
          </button>

          {/* Show up to 3 pages dynamically */}
          {filteredData.length > 0 &&
            [...Array(Math.min(3, Math.ceil(filteredData.length / itemsPerPage) - 1))].map((_, index) => {
              const pageNumber = currentPage + index;
              if (pageNumber > 1 && pageNumber <= Math.ceil(filteredData.length / itemsPerPage)) {
                return (
                  <button key={pageNumber} onClick={() => paginate(pageNumber)} className={currentPage === pageNumber ? 'active' : ''}>
                    {pageNumber}
                  </button>
                );
              }
              return null;
            })
          }

          {/* Next button */}
          <button onClick={() => paginate(currentPage + 1)} disabled={currentPage === Math.ceil(filteredData.length / itemsPerPage)}>
            Next
          </button>
        </div>
      </div>
    </div>
  );
};

export default SupplierMasterView;
